import React from 'react'

import { HeroTopicFrontVariant } from './HeroTopicFrontVariant.type'
import {
  HeroTopicFrontWithImage,
  HeroTopicFrontWithImageProps
} from './HeroTopicFrontWithImage'
import {
  HeroTopicFrontWithText,
  HeroTopicFrontWithTextProps
} from './HeroTopicFrontWithText'

export { HeroTopicFrontVariant } from './HeroTopicFrontVariant.type'
export type { HeroTopicFrontWithImageProps } from './HeroTopicFrontWithImage'
export type { HeroTopicFrontWithTextProps } from './HeroTopicFrontWithText'

export type HeroTopicFrontProps =
  | HeroTopicFrontWithImageProps
  | HeroTopicFrontWithTextProps

export const HeroTopicFront = (props: HeroTopicFrontProps) => {
  if (props.variant === HeroTopicFrontVariant.TEXT) {
    return <HeroTopicFrontWithText {...props} />
  }

  return <HeroTopicFrontWithImage {...props} />
}
